import {
  Box,
  Avatar,
  Stack,
  Card,
  Typography,
  Badge,
  Button,
  Grid,
} from "@mui/material";
import * as React from "react";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import { getCollectionIdByToken } from "../../../../CreateCollection/slice";
import { CollectionStatus, CollectionType } from "../../../../../common/enum";
import { PRODUCT_ICON } from "../../../../../common/enum/productIcon";
import ChatPanel from "../../../../MessagePanel/ChatPanel";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import SvgIconStyle from "../../../../../components/SvgIconStyle";
import { avataStyles, svgIconStyle } from "../../../../DonationView/Cart/styles";

import {
  collectionGroup,
  getDocs,
  where,
  collection as firebaseCollection,
  query,
  getCountFromServer,
  setDoc,
  serverTimestamp,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../../../../../firebase"
import { useDispatch, useSelector } from "react-redux";
const STATUS_PRESENT = {
  cancelled: CollectionStatus.cancelled,
  collected: CollectionStatus.collected,
  expired: CollectionStatus.expired,
};

const ProductGroupICon = ({ productIcon }) => {
  const filterIcon = React.useMemo(() => {
    return PRODUCT_ICON.filter((obj) =>
      productIcon.collectionProducts?.some(
        (ob) => ob.productGroup === obj.productGroup
      )
    );
  }, [productIcon, PRODUCT_ICON]);

  return (
    <Stack
      direction={"row"}
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
      }}
    >
      {filterIcon?.length > 0 &&
        filterIcon.map((itemImage) => (
          <Avatar
            key={itemImage.productGroup}
            alt={itemImage.productGroup}
            src={itemImage.url}
            sx={{
              width: 24,
              height: 24,
              ml: 0.2,
            }}
          />
        ))}
      {filterIcon?.length === 0 && (
        <Avatar
          alt={"evento"}
          src={"/static/icons/Icons/icon-event.png"}
          sx={{
            width: 24,
            height: 24,
            ml: 0.2,
          }}
        />
      )}
    </Stack>
  );
};

const Collection = ({ collectionDetails, allCollectionDetail, t }) => {
  const {
    dashboardInfo: { selectedDonation, cancelCollectionDonation },
    collection: { donorDetail },
    auth,
  } = useSelector((state) => state);
  const [select, setSelect] = React.useState(allCollectionDetail[0]);
  const [chatOpen, setChatOpen] = React.useState(false);
  const [selectedCollection, setSelectedCollection] = React.useState();
  const [showMore, setShowMore] = React.useState(false);
  const [MessageUserCount , setMessageUserCount]  = React.useState(0);
  const { userId, entityId } = auth.user || "";
 const dispatch = useDispatch();
  const toggleChatDrawer = React.useCallback((value) => {
    setChatOpen(value);
  }, []);
  const collectionStyle = {
    background: "#E1EFB1",
    paddingY: "2px",
    paddingX: "10px",
    borderRadius: "15px",
    color: "#37763D",
    fontWeight: "bold",
  };

  const handleClick = React.useCallback(
    (value) => {
      collectionDetails(value);
      setSelect(value);
    },

    []
  );


  const hasInitialized = React.useRef(false);

React.useEffect(() => {
  if (hasInitialized.current) return; // já inicializou, não faz nada

  if (!allCollectionDetail || allCollectionDetail.length === 0) {
    collectionDetails({});
    hasInitialized.current = true;
    return;
  }

  const queryString = window.location.search;
  const match = queryString.match(/collectionToken=([^&]*)/);
  const collectionToken = match ? match[1] : null;

  const selectFirstItem = () => {
    const selectedItem = allCollectionDetail[0];
    setSelect(selectedItem);
    collectionDetails(selectedItem);
    hasInitialized.current = true;
  };

  if (collectionToken) {
    dispatch(getCollectionIdByToken(collectionToken))
      .then((res) => {
        const decryptedId = res.payload;

        const selectedItem = allCollectionDetail.find(
          (item) => item.collection.id.toString() === decryptedId.toString()
        );

        if (selectedItem) {
          setSelect(selectedItem);
          collectionDetails(selectedItem);
        } else {
          console.warn(
            `Nenhuma coleção encontrada com id desencriptado: ${decryptedId}`
          );
          selectFirstItem();
        }
      })
      .catch((err) => {
        console.error("Erro ao obter collectionId do token:", err);
        selectFirstItem();
      });
  } else {
    selectFirstItem();
  }
}, [location.search, dispatch]);




  const handleChatDrawerClick = React.useCallback((value) => {
    setChatOpen(true);
    setSelectedCollection(value);
  }, []);

  const updateCollections = React.useMemo(() => {
    let arr = allCollectionDetail.reduce((r, obj) => {
      let time = new Date(
        obj?.collection.dateOfCollection
      ).toLocaleString("pt", {
        hour: "numeric",
      });
      r[time] = r[time] || [];
      r[time].push(obj);
      return r;
    }, {});
    return arr;
  }, [allCollectionDetail]);

  React.useEffect(() => {
    if (allCollectionDetail.length > 0) {
      collectionDetails(allCollectionDetail[0]);
      getMessageCount(allCollectionDetail[0].collection.id)

    } else {
      collectionDetails({});
    }
  }, [allCollectionDetail]);

  const getMessageCount = async (id,) => {
    try {
      const q = query(collectionGroup(db, "messages"),
        
        where("isRead", "==", false),
        where("collectionId", "==", id),
        where("recevierId",  "==", userId)
      );
  
      const querySnapshot = await getDocs(q);
     
      if (querySnapshot.empty) {
        // console.log("Nenhum documento encontrado para a consulta.");
        return { unReadCount: 0 };
      }

      setMessageUserCount(querySnapshot.docs.length);
  
      return { unReadCount: querySnapshot.docs.length };
    } catch (err) {
      // console.log("aqui --->", err.message);
    }
};

  const backgroundStatusColor = React.useCallback((status) => {
    if (status === CollectionStatus.collected) {
      return "#37773e";
    } else if (status === CollectionStatus.cancelled) {
      return "#ff0000";
    } else {
      return "transparent";
    }
  }, []);

  return (
    <>
      <Stack gap={1} marginTop="20px" sx={{ width: "80%", marginX: "auto" }}>
        <Grid container spacing={1} className="gridAgenda">
          {updateCollections &&
            Object.keys(updateCollections)
              .sort()
              .map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    width: 1,
                  }}
                >
                  <Grid item xs={1}>
                    <Typography color="text.primary" variant="body2" mt={1}>
                      {`${item}:00`}
                    </Typography>
                  </Grid>
                  <Grid item xs={11}>
                    <Stack
                      direction={"column"}
                      width={1}
                      alignItems={"center"}
                      spacing={1}
                    >
                      {updateCollections[item].slice(0, 3).map((newItem) => (
                        <Card
                          key={newItem?.collection.id}
                          variant={"outlined"}
                          onClick={() => handleClick(newItem)}
                          sx={{
                            background: "white",
                            p: 1,
                            mt: 1,
                            width: 1,
                            cursor: "pointer",
                            borderColor:
                              select?.collection.id === newItem?.collection?.id
                                ? "#37B34A"
                                : "",
                                maxWidth:'90%'
                          }}
                        >
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            sx={{ backgroundColor: "#fff" }}
                          >
                            <Stack gap={2} direction={"row"}>
                              <Typography
                                sx={{ textTransform: "uppercase" }}
                                variant="h6"
                                fontFamily={"Poppins"}
                              >
                                {new Date(
                                  newItem?.collection?.createdDate
                                ).getFullYear()}
                                {newItem?.collection?.id}
                              </Typography>
                              {Object.values(STATUS_PRESENT).includes(
                                newItem?.collection?.status
                              ) && (
                                <Typography
                                  variant="body1"
                                  fontFamily={"Poppins"}
                                  sx={{
                                    padding: 0.5,
                                    borderRadius: 0.5,
                                    color: "#fff",
                                    backgroundColor: backgroundStatusColor(
                                      newItem?.collection?.status
                                    ),
                                  }}
                                >
                                  {newItem?.collection?.status ===
                                    CollectionStatus.collected && (
                                    <EventAvailableIcon />
                                  )}
                                  {newItem?.collection?.status ===
                                    CollectionStatus.cancelled && (
                                    <EventBusyIcon />
                                  )}
                                  {t(
                                    `${Object.keys(STATUS_PRESENT).find(
                                      (ite) =>
                                        STATUS_PRESENT[ite] ===
                                        newItem?.collection?.status
                                    )}`
                                  )}
                                </Typography>
                              )}
                              
                              
                            </Stack>
                            <Stack
                              gap={2}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              {newItem?.messageCount?.count > 0 && (
                                <Button
                                  sx={{ minWidth: 0, color: "#1b727e" }}
                                  onClick={() => handleChatDrawerClick(newItem)}
                                >
                                  <Badge
                                    badgeContent={
                                      MessageUserCount
                                    }
                                    sx={{
                                      "& .MuiBadge-badge": {
                                        backgroundColor: "#1b727e",
                                        color: "#fff",
                                      },
                                    }}
                                    max={99}
                                  >
                                    <MessageOutlinedIcon />
                                  </Badge>
                                </Button>
                              )}
                              <ProductGroupICon productIcon={newItem} />
                            </Stack>
                          </Stack>
                        </Card>
                      ))}
                      {updateCollections[item].length > 3 && (
                        <Button
                          size="small"
                          variant="contained"
                          onClick={() => setShowMore(!showMore)}
                          endIcon={<ExpandCircleDownOutlinedIcon />}
                          sx={{
                            width: "fit-content",
                            color: "black",
                            fontWeight: "500",
                            borderRadius: "25px",
                            p: "8px 22px",
                            backgroundColor: "#E1EFB0",
                            "& .MuiButtonBase-root-MuiButton-root": {
                              color: "black !important",
                            },
                            "& .MuiButton-endIcon": {
                              transform: showMore
                                ? "rotate(-180deg)"
                                : "rotate(0deg)",
                            },
                            borderRadius:"4px"
                          }}
                        >
                          {t("viewMore")}{" "}
                          <span
                            style={{
                              textDecoration: "underline",
                              color: "#1b727e",
                              fontWeight: "600",
                              fontFamily: "Poppins",
                              margin: "0 5px",
                            }}
                          >
                            {`${updateCollections[item].length - 3}`}
                          </span>{" "}
                          {t("schedules")}
                        </Button>
                      )}
                      {showMore &&
                        updateCollections[item].length > 3 &&
                        updateCollections[item]
                          .slice(3, updateCollections[item].length)
                          .map((newItem) => (
                            <Card
                              key={newItem?.collection.id}
                              variant={"outlined"}
                              onClick={() => handleClick(newItem)}
                              sx={{
                                background: "white",
                                p: 1,
                                mt: 1,
                                width: 0.9,
                                cursor: "pointer",
                                borderColor:
                                  select?.collection.id ===
                                  newItem?.collection?.id
                                    ? "#37B34A"
                                    : "",
                              }}
                            >
                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                sx={{ backgroundColor: "#fff" }}
                              >
                                <Stack gap={2} direction={"row"}>
                                  <Typography
                                    sx={{ textTransform: "uppercase" }}
                                    variant="h6"
                                    fontFamily={"Poppins"}
                                  >
                                    {new Date(
                                      newItem?.collection?.createdDate
                                    ).getFullYear()}
                                    {newItem?.collection?.id}
                                  </Typography>
                                  {Object.values(STATUS_PRESENT).includes(
                                    newItem?.collection?.status
                                  ) && (
                                    <Typography
                                      variant="body1"
                                      fontFamily={"Poppins"}
                                    >
                                      {t(
                                        `${Object.keys(STATUS_PRESENT).find(
                                          (ite) =>
                                            STATUS_PRESENT[ite] ===
                                            newItem?.collection?.status
                                        )}`
                                      )}
                                    </Typography>
                                  )}
                                  {newItem?.messageCount?.count > 0 && (
                                    <Button
                                      sx={{ minWidth: 0, color: "#1b727e" }}
                                      onClick={() =>
                                        handleChatDrawerClick(newItem)
                                      }
                                    >
                                      <Badge
                                        badgeContent={
                                          newItem?.messageCount
                                            ? newItem?.messageCount?.unReadcount
                                            : 0
                                        }
                                        sx={{
                                          "& .MuiBadge-badge": {
                                            backgroundColor: "#1b727e",
                                            color: "#fff",
                                          },
                                        }}
                                        max={99}
                                      >
                                        <MessageOutlinedIcon />
                                      </Badge>
                                    </Button>
                                  )}
                                  
                                </Stack>
                                <Stack
                                  gap={2}
                                  direction={"row"}
                                  alignItems={"center"}
                                >
                                  <ProductGroupICon productIcon={newItem} />
                                  {/* 
                    <InfoIcon
                      onClick={() => collectionDetails(newItem?.colllection?.id)}
                      sx={{
                        background: "white",
                        fontSize: "32px",
                        padding: "4px",
                        color: "#37763D",
                      }}
                    /> */}
                                </Stack>
                              </Stack>
                            </Card>
                          ))}
                    </Stack>
                  </Grid>
                </Box>
              ))}
          {allCollectionDetail.length === 0 && (
            <Typography variant="h4" className="NoResultsAgenda">
            <Avatar sx={avataStyles}>
              <SvgIconStyle src="/static/dashboard/icon-emptyagenda.svg" sx={svgIconStyle} />
            </Avatar>
              Não existem agendamentos para este dia
            </Typography>
          )}
        </Grid>
      </Stack>
      <ChatPanel
        collection={selectedCollection}
        chatdrawerState={chatOpen}
        toggleChatDrawer={toggleChatDrawer}
        t={t}
      />
    </>
  );
};

export default Collection;
